import { schema } from "normalizr"

import item from "../projectDetails/item"

export default new schema.Array(item)
